import { Component } from 'react'
import { isChunkLoadError } from '../../utils/lazyWithRetry'

/**
 * Error boundary spécialisé pour les erreurs de chargement de modules
 * après un déploiement. Affiche un message "Nouvelle version disponible"
 * au lieu de l'écran de crash générique.
 */
export default class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasChunkError: false }
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      return { hasChunkError: true }
    }
    return null
  }

  componentDidCatch(error) {
    if (!isChunkLoadError(error)) {
      throw error
    }
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasChunkError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          fontFamily: 'Inter, sans-serif',
          color: '#333',
          padding: '2rem',
          textAlign: 'center',
        }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '0.75rem' }}>
            Nouvelle version disponible
          </h1>
          <p style={{ marginBottom: '1.5rem', color: '#666', maxWidth: '28rem' }}>
            BonUrba a été mis à jour. Veuillez recharger la page pour profiter de la dernière version.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#529371',
              color: '#fff',
              border: 'none',
              borderRadius: '0.5rem',
              cursor: 'pointer',
              fontSize: '1rem',
            }}
          >
            Recharger la page
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
